import { PaymentOption } from '~/pages/members/card.vue';
export default {
  data() {
    return {
      open: false,
      showActives: false,
      isMobile: false,
      showPurchaseMenu: false,
      skipPurchases: {
        facebook: false,
        gtm: false,
        // AFF-15
        everflow: false,
        prodege: false,
        tapjoy: false,
        fintel: false,
        lockerdome: false,
        bem: false,
        ppm: false
      },
      isCorporate: false,
      personaBypassed: false,
      errorContextString: '',
      warningContextString: ''
    };
  },
  computed: {
    nextDayPayment: {
      get() {
        return this.$parent.$data.paymentOption === PaymentOption.NEXT_DAY_ACH;
      },
      set(val) {
        this.$parent.$data.paymentOption = val ? PaymentOption.NEXT_DAY_ACH : PaymentOption.FOURTEEN_DAYS_ACH;
      }
    },
    plaidInsufficient: {
      get() {
        var _this$$parent$$data$p;
        return Boolean((_this$$parent$$data$p = this.$parent.$data.plaidInsufficient) === null || _this$$parent$$data$p === void 0 ? void 0 : _this$$parent$$data$p.insufficient) || false;
      },
      set(val) {
        this.$parent.$data.plaidInsufficient = val ? {
          success: true,
          insufficient: true,
          balance: 1,
          charge: 25
        } : {};
        if (!val) this.warningContext = false;
      }
    },
    errorContext: {
      get() {
        return Boolean(this.$parent.$data.errorContext);
      },
      set(val) {
        if (val) {
          this.$parent.$data.errorContext = {
            context: this.errorContextString
          };
        } else {
          this.$parent.$data.error = null;
          this.$parent.$data.errorContext = null;
        }
      }
    },
    warningContext: {
      get() {
        return Boolean(this.$parent.$data.warningContext);
      },
      set(val) {
        if (val && !this.warningContextString) {
          // warning page errors (ironic) if no warningContext
          alert('You need to provide a warning context or the site will break!');
          return;
        }
        this.$parent.$data.warningContext = val ? {
          context: this.warningContextString
        } : null;
      }
    }
  },
  watch: {
    showActives(val) {
      localStorage.setItem('EXTRA_DEV_SHOW_ACTIVES', val);
    }
  },
  mounted() {
    this.showActives = JSON.parse(localStorage.getItem('EXTRA_DEV_SHOW_ACTIVES', false));
    this.isMobile = window.innerWidth <= 400;
  },
  methods: {
    toggle() {
      this.open = !this.open;
      this.refreshOptionStates();
    },
    refreshOptionStates() {
      this.isCorporate = this.$parent.plaidAccountType === 'corporate';
    },
    toggleActives(e) {
      e.preventDefault();
      this.showActives = !this.showActives;
    },
    // for debug suite
    cd(condition, customTrue, customFalse) {
      return condition ? customTrue || 'text-green-500' : customFalse || 'text-red-500';
    },
    cdl(condition) {
      return this.cd(condition, 'ready-first');
    },
    woof() {
      window.alert('woof');
    },
    clearPlaid() {
      this.$parent.$data.plaidAccountId = null;
      this.$parent.$data.plaidAccessToken = null;
      this.$parent.$data.plaidPublicToken = null;
      this.$parent.$data.memberProfile.bank_account = null;
      this.$parent.$data.memberProfile.bank_linked = null;
    },
    togglePolling() {
      this.$parent.togglePolling();
    },
    clearDecision() {
      this.$parent.decisionStatus = null;
    },
    resetAccount() {
      return this.$axios.$post('/api/members/me/reset').then(data => {
        console.log('reset', data);
        window.location.reload();
      }).catch(console.error);
    },
    setCorporate() {
      this.isCorporate = !this.isCorporate;
      this.$parent.plaidAccountType = this.isCorporate ? 'corporate' : null;
    },
    setApplicationQueued(e) {
      this.$parent.$data.applicationQueued = e.target.checked;
      if (e.target.checked) {
        this.$parent.kycStatus = 'PASSED';
        this.$parent.kycSubmitted = true;
        this.$parent.formSubmitted = true;
        this.$parent.billingConfirmed = true;
        this.$parent.planSubmitted = true;
      }
    },
    setPersonaBypass() {
      this.personaBypassed = true;
      this.$parent.$data.forcePendingKyc = false;
      this.$parent.$data.memberProfile = {
        ...this.$parent.$data.memberProfile,
        persona: {
          ...this.$parent.$data.memberProfile.persona,
          inquiry_status: 'approved'
        },
        document_portal: {
          ...this.$parent.$data.memberProfile.document_portal,
          kyc_complete: true,
          kyc_required_docs: false,
          kyc_required_docs_hash: ''
        }
      };
    },
    async getFingerprints() {
      console.log(await this.$parent.getFingerprints());
    },
    checkAllClient() {
      this.skipPurchases.facebook = false;
      this.skipPurchases.gtm = false;
    },
    uncheckAllClient() {
      this.skipPurchases.facebook = true;
      this.skipPurchases.gtm = true;
    },
    // AFF-13
    checkAllServer() {
      this.skipPurchases.everflow = false;
      this.skipPurchases.prodege = false;
      this.skipPurchases.tapjoy = false;
      this.skipPurchases.fintel = false;
      this.skipPurchases.lockerdome = false;
      this.skipPurchases.bem = false;
      this.skipPurchases.ppm = false;
    },
    uncheckAllServer() {
      this.skipPurchases.everflow = true;
      this.skipPurchases.prodege = true;
      this.skipPurchases.tapjoy = true;
      this.skipPurchases.fintel = true;
      this.skipPurchases.lockerdome = true;
      this.skipPurchases.bem = true;
      this.skipPurchases.ppm = true;
    },
    pixelPurchase() {
      this.$parent.finishCallback({
        purchase: true,
        showError: false,
        skips: this.skipPurchases
      });
      console.log({
        skips: this.skipPurchases
      });
      this.clearError();
      this.$parent.billingConfirmed = true;
      this.$parent.formSubmitted = true;
      this.$parent.kycSubmitted = true;
      this.$parent.plaidAccountId = this.$parent.plaidAccountId || '123';
      this.$parent.plaidAccessToken = this.$parent.plaidAccessToken || this.$parent.plaidEnv;
      this.$parent.plan = this.$parent.plan || {
        billingCycle: 0,
        selectedPlan: 0
      };
      this.$parent.planSubmitted = true;
      this.$parent.kycStatus = 'PASSED';
      this.$axios.$post('/api/members/test-affiliate-postback', {
        skips: this.skipPurchases
      }).then(data => {
        console.log('[forced postback]', data);
        alert('[forced postback]: ' + JSON.stringify(data, null, 2));
      }).catch(err => {
        console.error('[forced postback]', err);
      });
    },
    updateIdentity() {
      this.$parent.updateIdentity();
    },
    promptECBSV() {
      this.$parent.updateIdentity();
    },
    clearError() {
      this.$parent.$data.error = null;
      this.$parent.$data.errorContext = null;
    },
    clearForm() {
      this.$parent.clearForm();
    }
  }
};